import { IconComponentProps } from '@bechtel/gds';

export interface SummaryItemProps {
  row: number;
  iconName: IconComponentProps['icon'];
  label: string;
  value?: string;
  values?: string[];
}
